import app from 'flarum/forum/app';
import addSidebarBox from './addSidebarBox';
import addListStat from './addListStat';
import addWishListToolbar from './addWishListToolbar';
export { default as extend } from './extend';
app.initializers.add('awaresoft-wish-votes', () => {
  addSidebarBox();
  addListStat();
  addWishListToolbar();
});